const URL_PORTS = {
  play: 8080,
  server: 3030,
};

export function getUrl(type, options) {
  if (!["play", "server"].includes(type)) {
    return null;
  }

  const { NODE_ENV, REACT_APP_DEPLOY, REACT_APP_USE_ALT_DOMAIN } = process.env;

  let url;

  if (REACT_APP_DEPLOY === "production") {
    url = new URL(`https://${type}.9dotsrewriters.org`);
  } else if (REACT_APP_DEPLOY === "qa") {
    url =
      REACT_APP_USE_ALT_DOMAIN === "true"
        ? new URL(`https://${type}-alt-rewriters-qa.web.app`)
        : new URL(`https://${type}.9dots-rewriters-qa.org`);
  } else if (REACT_APP_DEPLOY === "dev" && NODE_ENV === "production") {
    url = new URL(`https://${type}.9dots-biycr-dev.org`);
  } else {
    url = new URL(`http://localhost:${URL_PORTS[type]}`);
  }

  url.pathname = options?.pathname ?? '';
  url.hash = options?.hash ?? '';

  return url;
}

export function getOrigin(type) {
  return getUrl(type)?.origin ?? "";
}
